import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Streamer from "./Streamer";
import Viewer from "./Viewer";

function App() {
  
  return (
    <Router>
      <Routes>
        <Route path="/streamer" element={<Streamer />} />
        <Route path="/viewer" element={<Viewer />} />
      </Routes>
    </Router>
  );
}

export default App;
